import { readonly, ref } from "vue";
import { useEventListener } from "./event-listener";

export function useDocumentVisibilityChange(listener: (visible: boolean) => void) {
	if (typeof document === 'undefined') {
		return;
	}

	useEventListener(document, "visibilitychange", () => {
		listener(document.visibilityState === 'visible');
	});
}

export function useDocumentVisibility() {
	if (typeof document === 'undefined') {
		return readonly(ref(true));
	}

	const visible = ref(document.visibilityState === 'visible');

	useDocumentVisibilityChange(() => {
		visible.value = document.visibilityState === 'visible';
	});

	return readonly(visible);
}